






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card, Icon, Button, ButtonGroup } from '@alpha/ink'
import Redactor from '@/components/Redactor.vue'
import SaveRevertInput from '@/components/SaveRevertInput.vue'
import store from '@/store'

@Component({
  components: {
    Card,
    Icon,
    Button,
    ButtonGroup,
    Redactor,
    SaveRevertInput
  }
})
export default class SurveyFindings extends Vue {
  @Prop({ default: false }) publicView!: boolean

  get findings (): string[] {
    return store.state.surveyConfiguration.findings ?? []
  }

  get finding (): string {
    return this.findings[0] ?? ''
  }

  async saveNewFinding (newFinding: string) {
    const cleanedFindings = newFinding.trim() !== '' ? [newFinding] : []
    await store.dispatch.surveyConfiguration.saveFindings(cleanedFindings)
  }
}
